/* eslint quotes: 0 */
/* eslint max-len: 0 */

import { newSearchDone$ } from "@sharedFrontend/globalEvents";
import { markerClicked$ } from "./marker.component";

export default class ApartmentPopupComponent {
    /**
     * @param {Object} innerMap - google maps map
     */
    constructor(innerMap, texts, mapClicked$) {
        this.innerMap = innerMap;
        this.texts = texts;
        this.targetMarker = null;
        this.infowindow = null;

        this.initialize(mapClicked$);
    }

    /**
     * @private
     */
    initialize(mapClicked$) {
        this.initializeInnerComponent();
        this.initializeEventHandlers(mapClicked$);
    }

    /**
     * @private
     */
    initializeInnerComponent() {
        // eslint-disable-next-line no-undef
        this.infowindow = new InfoBox({
            alignBottom: true,
            // eslint-disable-next-line no-undef
            pixelOffset: new google.maps.Size(-30, 0),
            pane: "floatPane",
            closeBoxURL: "",
            // eslint-disable-next-line no-undef
            infoBoxClearance: new google.maps.Size(25, 50),
        });
    }

    /**
     * @private
     */
    initializeEventHandlers(mapClicked$) {
        markerClicked$.subscribe((args) => {
            const { data, target } = args;
            this.targetMarker = target;
            this.infowindow.setContent(this.createContent(data));
        });

        this.infowindow.addListener("content_changed", () => {
            this.infowindow.open(this.innerMap, this.targetMarker);
            this.infowindow.show();
        });

        newSearchDone$.subscribe(() => {
            this.infowindow.hide();
        });

        mapClicked$.subscribe(() => {
            this.infowindow.hide();
        });
    }

    /**
     * @private
     * @param {Object} place - comes from marker
     */
    // eslint-disable-next-line class-methods-use-this
    createContent(place) {
        const fullName = `${place.apartmentPropertyName} ${place.apartmentPropertyCity}`;

        const tiles = Array.prototype.slice.call(document.querySelectorAll(`div[data-property-id='${place.itemId}']`));
        if (tiles.length > 0) {
            const tile = tiles[0];

            const availalbeRows = Array.prototype.slice.call(tile.querySelectorAll(".available-apartments .apartment-row"));
            const hasVisibleAvailable = availalbeRows.some(r => !r.classList.contains("d-none"));
            const amountAvailable = hasVisibleAvailable ? availalbeRows.length : 0;

            const otherRows = Array.prototype.slice.call(tile.querySelectorAll(".other-apartments .apartment-row"));
            const hasVisibleOther = otherRows.some(r => !r.classList.contains("d-none"));
            const amountOther = hasVisibleOther ? otherRows.length : 0;

            let noFreeApartmentsContent = "";
            let otherApartmentsContent = "";

            const freeApartmentContent = amountAvailable > 0
                ? `<div>${this.texts.textApartmentAmountFreeApartments}: ${amountAvailable}</div>`
                : "";

            if (freeApartmentContent === "") {
                noFreeApartmentsContent = `<div>${this.texts.textApartmentNoFreeApartments}</div>`;

                if (amountOther > 0) {
                    otherApartmentsContent = `<div>${
                        this.texts.textApartmentAmountOtherApartments
                    }: ${amountOther}</div>`;
                }
            }

            return (
                '<div class="apartment-popup-content">'
                + `<div style='background-image: url("${place.apartmentPropertyImageUrl}");'></div>`
                + `<div><strong>${fullName}</strong></div>`
                + `${freeApartmentContent}`
                + `${noFreeApartmentsContent}`
                + `${otherApartmentsContent}`
                + `<a href='${place.apartmentPropertyUrl}' target="_blank"><strong>${
                    this.texts.textApartmentApartmentPropertyLink
                }</strong></a>`
                + "</div>"
            );
        }

        const amountText = place.amountAvailableApartments > 0
            ? `${this.texts.textApartmentAmountFreeApartments}: ${place.amountAvailableApartments}`
            : this.texts.textApartmentNoFreeApartments;

        return (
            '<div class="apartment-popup-content">'
            + `<div style='background-image: url("${place.apartmentPropertyImageUrl}");'></div>`
            + `<div><strong>${fullName}</strong></div>`
            + `<div>${amountText}</div>`
            + `<a href='${place.apartmentPropertyUrl}' target="_blank"><strong>${
                this.texts.textApartmentApartmentPropertyLink
            }</strong></a>`
            + "</div>"
        );
    }
}
